import React, { useState } from "react";

function TreeNode({ item, onToggle, level = 0 }) {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = item.items && item.items.length > 0;

  const handleToggle = () => {
    onToggle({ ...item, selected: !item.selected });
  };

  const handleExpandCollapse = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="mb-1" style={{ paddingLeft: `${level * 20}px` }}>
      <div className="d-flex align-items-center">
        {hasChildren && (
          <button
            type="button"
            className="btn btn-sm btn-link p-0 me-1"
            onClick={handleExpandCollapse}
            title={expanded ? "Colapsar" : "Expandir"}
          >
            {expanded ? "▼" : "►"}
          </button>
        )}
        {!hasChildren && <span style={{ width: "12px" }} />}
        <input
          type="checkbox"
          className="form-check-input me-2"
          checked={item.selected || false}
          onChange={handleToggle}
        />
        <span title={`${item.text?.trim()} - CORE: ${item.core}`}>
          {item.text}
        </span>
      </div>

      {hasChildren && expanded && (
        <div>
          {item.items.map((child) => (
            <TreeNode
              key={child.id}
              item={child}
              onToggle={onToggle}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default function TreeViewCustom({ items, onItemToggle }) {
  return (
    <div>
      {items.map((item) => (
        <TreeNode key={item.id} item={item} onToggle={onItemToggle} />
      ))}
    </div>
  );
}
